export enum TrackingViewType {
  ESTIMATION,
  VALUATION_REQUEST,
  VALUATION_SUCESS
}
